
import {defineComponent} from "vue";

export default defineComponent({
  name: 'TermsOfUsePage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
